import * as HTTP from './http';

export const GetBaggers = async() => {
    let endpoint = `devices/type/baggers`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: devices.GetBaggers\n${e}`);
        return undefined;
    }

    return result;
}